import { Card, CardContent, Grid } from '@mui/material';

import { ProjectType } from '../../../models/project';
import { useFormContext, useWatch } from 'react-hook-form';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormSelect } from '../../../components/hook-form/form-select.component';
import { SelectFieldOption } from '../../../components/hook-form/hook-form-error';
import { LoadingIndicator } from '../../../components/loading-indicator.component';
import { rebateCompanyApiKeyStore } from '../../../api/masters/rebate-company-api-key-store';
import { projectSubTypeApiKeyStore } from '../../../api/masters/project-subtype-api-key-store';
import { FormAutoCompleteMultiSelectDynamic } from '../../../components/hook-form/form-autocomplete-multi-select.dynamic.component';
import { FormAutoCompleteSelectDynamic } from '../../../components/hook-form/form-autocomplete-select.dynamic.component';
import { divisionApiKeyStore } from '../../../api/masters/division-api-key-store';
import { planApiKeyStore } from '../../../api/plan-api-key-store';
import { FormCheckbox } from '../../../components/hook-form/form-checkbox.component';
import { useAuthorize } from '../../../hooks/use-authorize';
import { UserPermissionName } from '../../../models/user-permission-name';
import { useEffect, useState } from 'react';
import { ConfirmDialogComponent } from './comfirm-dialog.component';
import { useSaveData } from '../../../hooks/useSaveData';
import { customersApiKeyStore } from '../../../api/customers-api-key-store';
import { FormCheckboxSelect } from '../../../components/hook-form/form-checkbox-select.component';
import FormDateField, { DateFormat } from '../../query-builder/hooks-form-querybuilder/form-date.field.component';
import { departmentsApiKeyStore } from '../../../api/masters/department-api-key-store';

const commercialOptions: SelectFieldOption[] = [{ value: ProjectType.Buildings, label: 'Buildings', isDefault: true }];
const recidentialOptions: SelectFieldOption[] = [
  { value: ProjectType.ResidentialSingleLot, label: 'Single Lot', isDefault: true },
  { value: ProjectType.ResidentialCommunity, label: 'Community' },
  { value: ProjectType.CommunityScatteredLot, label: 'Scattered Lot ' },
];
const rebateOptions: SelectFieldOption[] = [
  { value: 'processing', label: 'Processing', isDefault: false },
  { value: 'notProcessing', label: 'Not Processing', isDefault: false },
  { value: 'notqualify', label: 'Does Not Qualify', isDefault: false },
  { value: 'norebate', label: 'No Rebate Program Available', isDefault: false },
];

const ffServiceCat: SelectFieldOption[] = [
  { value: 'Third-Party Only', label: 'Third-Party Only', isDefault: false },
  { value: 'Third-Party and PPI', label: 'Third-Party and PPI', isDefault: false },
  { value: 'PPI Only', label: 'PPI Only', isDefault: false },
];

// const sendEmailOption: SelectFieldOption[] = [];


interface ProjectInfoComponent {
  isEdit?: boolean;
  project?: any;
  isCustomerLoading?: boolean;
  rebateValue: string;
}

const isDUXEnabled = process.env.REACT_APP_DUX_FLAG === 'true';
export const ProjectInfoComponent = ({ isEdit, project, isCustomerLoading, rebateValue }: ProjectInfoComponent) => {
  const { setValue, getValues } = useFormContext();
  const [disableEmail, setDisabledEmail] = useState<boolean>(true);
  const [rebateChange, setRebateChange] = useState<any>(null);
  const [serviceCatChange, setServiceCatChange] = useState<any>(null);
  const [confirmDialog, setConfirmDialog] = useState<boolean>(false);
  const [actionValue, setActionValue] = useState<any>();
  const [actionType, setActionType] = useState<any>();
  const [sendEmailOption, setEmailOption] = useState<SelectFieldOption[]>([])

  useWatch({
    name: ['rebates', 'ffServiceCat', 'syncWithDuxCustomer'] || [],
  });
  const projectType = getValues('projectType');

  const typeOptions = () => {
    if (projectType === ProjectType.Commercial) {
      return commercialOptions;
    } else if (projectType === ProjectType.Residential) {
      return recidentialOptions;
    }
    return [];
  };

  const handleFastFieldService = (value: any) => {
    if (isEdit) {
      setActionType('Fastfield Service Cat');
      setActionValue(value);
      setConfirmDialog(true);
    }
  };

  const handleRebate = (value: any) => {
    if (isEdit) {
      setActionType('Rebates');
      setActionValue(value);
      setConfirmDialog(true);
    } else {
      if (value !== 'processing') {
        setValue('rebateCompanies', null);
      }
    }
  };

  const handleActionSubmit = (value: any, type: any) => {
    if (type == 'Rebates') {
      setRebateChange(value);
      setValue('rebates', value);
      if (value !== 'processing') {
        setValue('rebateCompanies', null);
      }
    }
    if (type == 'Fastfield Service Cat') {
      setServiceCatChange(value);
      setValue('ffServiceCat', value);
    }
    setConfirmDialog(false);
  };

  const handleActionClosed = (type: string) => {
    if (type == 'Rebates') {
      setValue('rebates', rebateChange ? rebateChange : project?.rebates ?? '');
    }
    if (type == 'Fastfield Service Cat') {
      setValue('ffServiceCat', serviceCatChange ? serviceCatChange : project?.ffServiceCat ?? '');
    }
    setConfirmDialog(false);
  };

  const isSyncWithDuxPermission = useAuthorize([UserPermissionName?.SYNC_WITH_DUX]);

  const {
    isLoading: isloadingSyuncWithDux,
    mutateAsync,
    data: duxSyncStatusChangeData,
  } = useSaveData<any>(customersApiKeyStore.duxSyncStatusChange());

  const handleChangeSyncWithDux = (e: any) => {
    setValue('syncWithDux', !e.target.checked);
    mutateAsync({
      data: {
        projectID: project?.projectID ?? 0,
        officeID: 0,
        customerID: 0,
        syncWithDux: e.target.checked,
      },
    }).then(() => {
      setValue('syncWithDux', !e.target.checked);
    });
  };

  const handleDivisionChange = (divisionValue: any) => {
    setDisabledEmail(divisionValue?.length > 0 ? false : true);
    const newOptions = divisionValue?.map((item: any) => ({
      value: item?.divisionID,
      label: item?.divisionName,
      isDefault: false,
    }));

    setEmailOption(newOptions);
    // divisionValue?.forEach((item: any) => {
    //   const exists = sendEmailOption?.some(entry => entry.value === item.divisionID);
    //   if (!exists) {
    //     sendEmailOption?.push({
    //       value: item.divisionID,
    //       label: item.divisionName,
    //       isDefault: false
    //     });
    //   }
    // });
    setValue('sendEmail', divisionValue
      ?.filter((division: any) => division?.sendEmailReminder)
      ?.map((division: any) => division.divisionID) ?? []);
  }

  useEffect(() => {
    if (getValues('projectDivisions')) {
      handleDivisionChange(getValues('projectDivisions'))
    }
  }, [getValues('projectDivisions')])


  const isUATEnable = process.env.REACT_APP_UAT_FLAG === 'true';
  return (
    <>
      <Card elevation={0}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item lg={7} sm={7} xl={7} xs={7}>
              <Grid container spacing={2}>
                <Grid item lg={8} sm={8} xl={8} xs={8}>
                  <FormInput
                    name="projectName"
                    label="Project Name"
                    validationQueryRoute={(value: string) =>
                      getValues('office.officeID') &&
                      projectsApiKeyStore.validateProject(
                        getValues('office.officeID') ?? 0,
                        value,
                        project?.projectID ?? 0
                      )
                    }
                  />
                </Grid>
                <Grid item lg={4} sm={4} xl={4} xs={4} className="formItemGroup">
                  <FormInput name="builderCode" label="Builder Code" disabled />
                  <FormInput
                    name="projectCode"
                    label="Project Code"
                    validationQueryRoute={(value: string) =>
                      getValues('office.officeID') &&
                      getValues('builderCode') &&
                      projectsApiKeyStore.validateProjectCode(
                        value,
                        getValues('builderCode') ?? '',
                        getValues('office.officeID') ?? 0,
                        project?.projectID ?? 0
                      )
                    }
                  />
                </Grid>
                <Grid item lg={4} sm={4} xl={4} xs={4}>
                  <FormInput name="feeOwner" label="Fee Owner" />
                </Grid>
                {projectType !== ProjectType.TimeAndMaterial && (
                  <Grid item lg={4} sm={4} xl={4} xs={4}>
                    <FormSelect name="projectCommunityType" label="Type" options={typeOptions()} disabled={isEdit} />
                  </Grid>
                )}
                <Grid item lg={4} sm={4} xl={4} xs={4}>
                  <FormAutoCompleteMultiSelectDynamic
                    name="projectSubTypes"
                    label="Project Subtype"
                    getQueryKeyConfig={() => projectSubTypeApiKeyStore.getProjectSubTypes()}
                    optionsLabelKey="projectSubType"
                    optionsValueKey="projectSubTypeID"
                  />
                </Grid>
                <Grid item lg={4} sm={4} xl={4} xs={4}>
                  <LoadingIndicator isLoading={isCustomerLoading} />
                  <FormSelect name="rebates" label="Rebates" onChange={handleRebate} options={rebateOptions} />
                </Grid>
                <Grid item lg={4} sm={4} xl={4} xs={4}>
                  <FormAutoCompleteSelectDynamic
                    name="rebateCompanies"
                    label="Rebate/Utility Company"
                    disabled={getValues('rebates') == 'processing' ? false : true}
                    getQueryKeyConfig={() => rebateCompanyApiKeyStore.getRebateCompanies()}
                    optionsValueKey="utilRebateCompanyID"
                    optionsLabelKey="utilRebateCompanyName"
                  />
                </Grid>
                <Grid item lg={4} sm={4} xl={4} xs={4}>
                  <FormAutoCompleteMultiSelectDynamic
                    name="projectDivisions"
                    label="Division"
                    onChange={handleDivisionChange}
                    getQueryKeyConfig={() => divisionApiKeyStore.getOfficeDivisions(getValues('office.officeID'))}
                    optionsValueKey="divisionID"
                    optionsLabelKey={'divisionName'}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={5} sm={5} xl={5} xs={5}>
              <FormInput name="description" label="Description" multiline size={6.0} />
            </Grid>
            <Grid item lg={3} sm={3} xl={3} xs={3}>
              <FormAutoCompleteMultiSelectDynamic
                name="planReviews"
                label="Plan Review"
                getQueryKeyConfig={() => planApiKeyStore.getPlanReviewTypes()}
                optionsValueKey="planReviewTypeID"
                optionsLabelKey="planReviewTypeName"
              />
            </Grid>
            <Grid item lg={3} sm={3} xl={3} xs={3}>
              <FormSelect
                name="ffServiceCat"
                label="Fastfield Service Cat"
                // onChange={handleFastFieldService}
                options={ffServiceCat}
              />
            </Grid>
            {!disableEmail && (
              <Grid item lg={3} sm={3} xl={3} xs={3}>
                <FormCheckboxSelect
                  name="sendEmail"
                  label="Send Reminder Email"
                  options={sendEmailOption}
                />
              </Grid>
            )}
            <Grid item lg={3} sm={3} xl={3} xs={3}>
              <FormAutoCompleteSelectDynamic
                name="departments"
                label="Department"
                getQueryKeyConfig={() => departmentsApiKeyStore.getDepartmentsWithManager()}
                optionsValueKey="departmentID"
                optionsLabelKey="departmentName"
              />
            </Grid>
            {isUATEnable && (
              <>
                <Grid item xl={3} lg={3} sm={3} xs={2}>
                  <FormDateField
                    label="Forecast Start Date"
                    name="forecastStartDate"
                    format={DateFormat.SIMPLE_DATE}
                  />
                </Grid>
                <Grid item xl={3} lg={3} sm={3} xs={2}>
                  <FormInput
                    name="estimatedStartsPerMonth"
                    label="Estimated Starts per Month"
                    type='number'
                  />
                </Grid>
              </>
            )}

            <Grid item lg={3} sm={3} xl={3} xs={3}>
              <Grid
                container
                direction="row"
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <FormCheckbox
                  label="Include HVAC Grading"
                  name="includeHVACGrading"
                />
                {isDUXEnabled && isSyncWithDuxPermission && (
                  <>
                    <LoadingIndicator isLoading={isloadingSyuncWithDux} />
                    <FormCheckbox
                      label="Sync With DUX"
                      name="syncWithDux"
                      disabled={!getValues('syncWithDuxCustomer')}
                      onChange={!project?.projectID ? undefined : handleChangeSyncWithDux}
                    />
                  </>
                )}
              </Grid>
            </Grid>

          </Grid>
        </CardContent>
      </Card>
      <ConfirmDialogComponent
        openDialog={confirmDialog}
        value={actionValue}
        type={actionType}
        onSubmit={handleActionSubmit}
        onClosed={handleActionClosed}
      />
    </>
  );
};
